import React from 'react';

interface EmptyStateProps {
    /** Ícono pequeño y discreto — nunca una ilustración gigante desvanecida */
    icon?: React.ReactNode;
    title: string;
    description?: string;
    /** Acción primaria (usa <Button>) */
    action?: React.ReactNode;
    /** 'vacio' = nunca hubo datos · 'filtro' = hay datos pero el filtro no arroja nada · 'error' */
    variant?: 'vacio' | 'filtro' | 'error';
    className?: string;
}

/**
 * EmptyState — Sistema 2.0.
 * Sin bordes punteados ni íconos gigantes al 20% de opacidad (la firma más
 * clara del template genérico). Ícono chico en un cuadro sutil, jerarquía de
 * texto clara y una sola acción.
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
    icon, title, description, action, variant = 'vacio', className = '',
}) => {
    const iconBox =
        variant === 'error'
            ? 'bg-peligro-bg text-peligro'
            : 'bg-acero-100 text-acero-500';

    return (
        <div className={`flex flex-col items-center justify-center text-center py-16 px-6 ${className}`}>
            {icon && (
                <div className={`w-10 h-10 rounded-xl grid place-items-center mb-4 ${iconBox}`} aria-hidden="true">
                    {icon}
                </div>
            )}
            <p className="text-[15px] font-semibold tracking-tight text-navy-950">{title}</p>
            {description && (
                <p className="text-sm text-acero-500 mt-1.5 max-w-sm">{description}</p>
            )}
            {action && <div className="mt-5">{action}</div>}
        </div>
    );
};
